var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2AB7F8",
    d: "M7.32149 7.32145L7.76343 6.87951L7.76343 6.87951L7.32149 7.32145ZM9.67851 7.32145L9.23657 6.87951L9.23657 6.87951L9.67851 7.32145ZM1.83333 1.625H15.1667V0.375H1.83333V1.625ZM15.375 1.83333V11.8333H16.625V1.83333H15.375ZM15.1667 12.0417H1.83333V13.2917H15.1667V12.0417ZM1.625 11.8333V1.83333H0.375V11.8333H1.625ZM1.83333 12.0417C1.71827 12.0417 1.625 11.9484 1.625 11.8333H0.375C0.375 12.6387 1.02792 13.2917 1.83333 13.2917V12.0417ZM15.375 11.8333C15.375 11.9484 15.2817 12.0417 15.1667 12.0417V13.2917C15.9721 13.2917 16.625 12.6387 16.625 11.8333H15.375ZM1.83333 0.375C1.4308 0.375 1.06536 0.538914 0.802136 0.802136L1.68602 1.68602C1.7244 1.64763 1.77563 1.625 1.83333 1.625V0.375ZM0.802136 0.802136C0.538914 1.06536 0.375 1.4308 0.375 1.83333H1.625C1.625 1.77563 1.64763 1.7244 1.68602 1.68602L0.802136 0.802136ZM15.1667 1.625C15.2244 1.625 15.2756 1.64764 15.314 1.68602L16.1979 0.802137C15.9346 0.538913 15.5692 0.375 15.1667 0.375V1.625ZM15.314 1.68602C15.3524 1.7244 15.375 1.77563 15.375 1.83333H16.625C16.625 1.4308 16.4611 1.06536 16.1979 0.802137L15.314 1.68602ZM6.87955 7.76339C7.7745 8.65834 9.2255 8.65834 10.1205 7.76339L9.23657 6.87951C8.82977 7.2863 8.17023 7.2863 7.76343 6.87951L6.87955 7.76339ZM0.802137 1.68602L6.87955 7.76339L7.76343 6.87951L1.68602 0.802135L0.802137 1.68602ZM10.1205 7.76339L16.1979 1.68602L15.314 0.802135L9.23657 6.87951L10.1205 7.76339Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.d89fac30d0773092888c75e5e689aa80.svg";
export { ForwardRef as ReactComponent };